module.exports = "<div layout-fill layout=column layout-align=\"start center\" class=\"gz-view-container page-not-found-container\"><div translate=uxf.uxf.Page_Not_Found class=page-not-found-title></div><md-icon layout=column layout-align=\"center center\" md-svg-src=/images/logos/PrintOS.svg class=production-image></md-icon><div ng-if=vm.reason translate={{vm.reason}} class=page-not-found-reason></div><div ng-if=vm.detail translate={{vm.detail}} class=page-not-found-detail></div></div>";


//////////////////
// WEBPACK FOOTER
// ../~/@printos/gazelle/src/components/page-not-found/page-not-found.jade
// module id = 249
// module chunks = 0